import {
    PermissionGroup,
    Banner,
    OwnTeamManagement,
    CampaignManagement,
    Ambassador,
} from 'components/Shared/Permission/enums'

export const roles = [
    {
        uuid: 'test001',
        name: 'user001',
        description: 'test tes ',
        member_count: 3,
        permissions: ['parole-team-permission01'],
    },
]

// this is to control which permission should not display in permission table
export const UnchangeablePermissionsCodes: string[] = [
    Banner.CreateBanner,
    Banner.DisableBanner,
    OwnTeamManagement.CreateTeam,
    CampaignManagement.EditDefaultTags,
    Ambassador.AddRemoveFavourite,
]
// this is to control which permission group should not display in permission table
export const UnchangeablePermissionsGroup: string[] = [PermissionGroup.AmbassadorsManagement]
